export default __webpack_public_path__ + "83bebaf37c09c7e1c3ee52682892ae14.woff";